// Shared z-order counter — desktop windows AND the signing workbench draw
// from the same stack so whatever was touched last sits on top.
export const deskZ = { v: 50 };
export const nextZ = () => ++deskZ.v;
